import { render } from "./DneExchange.vue?vue&type=template&id=263a79e8&scoped=true"
import script from "./DneExchange.vue?vue&type=script&lang=js"
export * from "./DneExchange.vue?vue&type=script&lang=js"

import "./DneExchange.vue?vue&type=style&index=0&id=263a79e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263a79e8"]])

export default __exports__